import { Pipe, PipeTransform } from '@angular/core';

import { Record } from '../models/record/record.class';
import { RecordField } from '../models/record/recordfield.class';

@Pipe({
    name: 'PrimaryHeaderRecordFields',
    standalone: false,
})
export class PrimaryHeaderRecordFieldsPipe implements PipeTransform {
    transform(fields: RecordField[], record: Record): RecordField[] {
        if ((record.showInListCount as number) > 0) {
            return fields?.filter(field => field.showInList);
        }
        record.showInListCount;
        record.businessKeysCount;
        return fields?.filter(field => field.preCaptureType === 'FILING' || field.isBusinessKey || field.isMandatory);
    }
}
